import React from "react";
import { motion } from "framer-motion";
import { revealUp } from "@/lib/motion";

/**
 * Renders a block of text, one line per array item, with a masked slide-up reveal.
 * Each line is wrapped in overflow-hidden; the inner span animates from 110% → 0%.
 */
export default function MaskedLines({
  lines = [],
  className = "",
  lineClassName = "",
  startDelay = 0,
  as: Tag = "h1",
  testId,
}) {
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span
          key={i}
          className={`reveal-mask block ${lineClassName}`}
        >
          <motion.span
            className="block"
            custom={i}
            variants={{
              hidden: { y: "115%" },
              show: (idx) => ({
                y: "0%",
                transition: {
                  duration: 1.15,
                  ease: [0.76, 0, 0.24, 1],
                  delay: startDelay + idx * 0.12,
                },
              }),
            }}
            initial="hidden"
            animate="show"
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </Tag>
  );
}
